import styled, { css } from 'styled-components';

const IS_IE11 = typeof window !== 'undefined' && window.navigator && /rv:11.0/i.test(window.navigator.userAgent);

export const Container = styled.div`
  position: relative;
  perspective: 1000px;
  width: 350px;
  height: 200px;
  font-size: 16px;
  text-align: left;
`;

export const Card = styled.div<{ isFlipped?: boolean; brand?: string; hasShadow?: boolean; hasRadialGradient?: boolean }>`
  border-radius: 10px;
  line-height: 1;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 315px;
  transform-style: preserve-3d;
  transition: all 400ms linear;

  ${props => props.hasShadow && css`
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  `}

  ${props => props.isFlipped && css`
    transform: rotateY(180deg);
  `}

  ${() => IS_IE11 && css`
    &.flipped {
      transform: 0deg;
    }
  `}
`;

export const Front = styled.div<{ brand?: string; hasRadialGradient?: boolean }>`
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  transition: all 400ms linear;
  -webkit-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  border-radius: 10px;
  background: #777777;
  z-index: 0;

  ${props => {
    if (props.brand === 'visa') {
      return css`background: #191278;`;
    }
    if (props.brand === 'mastercard') {
      return css`background: #0061a8;`;
    }
    if (props.brand === 'elo') {
      return css`background: linear-gradient(135deg, #00a859 0%, #00a859 50%, #00a859 100%);`;
    }
    return '';
  }}

  ${() => IS_IE11 && css`
    &.flipped {
      transform: rotateY(0deg);
    }
  `}

  &::before {
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: ${props => props.brand && props.brand !== 'unknown' ? 0.7 : 0};
    border-radius: 10px;
    transition: all 400ms ease;

    ${props => !props.hasRadialGradient && css`
      background-image: repeating-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.05) 1px,
          rgba(255, 255, 255, 0) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.03) 4px
        ),
        repeating-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          210deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        linear-gradient(
          -25deg,
          rgba(255, 255, 255, 0) 50%,
          rgba(255, 255, 255, 0.4) 70%,
          rgba(255, 255, 255, 0) 90%
        );
    `}

    ${props => props.hasRadialGradient && css`
      background-image: repeating-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.05) 1px,
          rgba(255, 255, 255, 0) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.03) 4px
        ),
        repeating-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          210deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 30% 30%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 70% 70%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 90% 20%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 15% 80%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        linear-gradient(
          -25deg,
          rgba(255, 255, 255, 0) 50%,
          rgba(255, 255, 255, 0.4) 70%,
          rgba(255, 255, 255, 0) 90%
        );
    `}
  }
`;

export const Back = styled.div<{ brand?: string; hasRadialGradient?: boolean }>`
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  transition: all 400ms linear;
  -webkit-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  border-radius: 10px;
  background: #777777;
  z-index: 0;
  transform: rotateY(180deg);

  ${props => {
    if (props.brand === 'visa') {
      return css`background: #191278;`;
    }
    if (props.brand === 'mastercard') {
      return css`background: #0061a8;`;
    }
    if (props.brand === 'elo') {
      return css`background: linear-gradient(135deg, #00a859 0%, #00a859 50%, #00a859 100%);`;
    }
    return '';
  }}

  ${() => IS_IE11 && css`
    &::after {
      left: 14%;
    }
  `}

  &::after {
    content: "";
    display: block;
    background-color: #fff;
    background-image: linear-gradient(#fff, #fff);
    width: 80%;
    height: 16%;
    position: absolute;
    top: 40%;
    left: 2%;
  }

  &::before {
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: ${props => props.brand && props.brand !== 'unknown' ? 0.7 : 0};
    border-radius: 10px;
    transition: all 400ms ease;

    ${props => !props.hasRadialGradient && css`
      background-image: repeating-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.05) 1px,
          rgba(255, 255, 255, 0) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.03) 4px
        ),
        repeating-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          210deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        linear-gradient(
          -25deg,
          rgba(255, 255, 255, 0) 50%,
          rgba(255, 255, 255, 0.4) 70%,
          rgba(255, 255, 255, 0) 90%
        );
    `}

    ${props => props.hasRadialGradient && css`
      background-image: repeating-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.05) 1px,
          rgba(255, 255, 255, 0) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.03) 4px
        ),
        repeating-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-linear-gradient(
          210deg,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 30% 30%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 70% 70%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 90% 20%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        repeating-radial-gradient(
          circle at 15% 80%,
          rgba(255, 255, 255, 0) 1px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.04) 3px,
          rgba(255, 255, 255, 0.05) 4px
        ),
        linear-gradient(
          -25deg,
          rgba(255, 255, 255, 0) 50%,
          rgba(255, 255, 255, 0.4) 70%,
          rgba(255, 255, 255, 0) 90%
        );
    `}
  }

  ${() => IS_IE11 && css`
    transform: rotateY(0deg);
  `}
`;

export const Lower = styled.div`
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 30px;
`;

export const Shiny = styled.div`
  width: 50px;
  height: 35px;
  margin-bottom: 10px;
  border-radius: 5px;
  background: #ccc;
  position: relative;

  &::before {
    content: " ";
    display: block;
    width: 70%;
    height: 60%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #d9d9d9;
    position: absolute;
    top: 20%;
  }

  &::after {
    content: attr(data-after);
    position: absolute;
    left: 120%;
    top: 5%;
    color: white;
    font-size: 7px;
    width: 230px;
    opacity: 0.5;
  }

  ${Back} & {
    position: absolute;
    top: 66%;
    left: 2%;

    ${() => IS_IE11 && css`
      left: 84%;

      &::after {
        left: -480%;
        transform: rotateY(180deg);
      }
    `}
  }
`;

interface LogoContainerProps {
 isPositionAbsolute: boolean;
 width: string;
 height: string;
}

export const LogoContainer = styled.div<LogoContainerProps>`
  ${(props) => props.isPositionAbsolute && `
    position: absolute;
    right: 0;
    top: 0;
  `}
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  box-sizing: border-box;
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
`;

export const Bar = styled.div`
  background-color: #444;
  background-image: linear-gradient(#444, #333);
  width: 100%;
  height: 20%;
  position: absolute;
  top: 10%;
`;

export const Number = styled.div<{ focused?: boolean }>`
  font-family: "Bitstream Vera Sans Mono", Consolas, Courier, monospace;
  font-size: 24px;
  clear: both;
  margin-bottom: 30px;
  color: white;
  font-weight: normal;
  opacity: 0.5;
  transition: opacity 400ms linear;

  ${props => props.focused && css`
    opacity: 1;
    font-weight: 700;
  `}
`;

export const Name = styled.div<{ focused?: boolean }>`
  text-transform: uppercase;
  font-family: "Bitstream Vera Sans Mono", Consolas, Courier, monospace;
  font-size: 20px;
  max-height: 45px;
  position: absolute;
  bottom: 0;
  width: 190px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: horizontal;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2em;
  color: white;
  font-weight: normal;
  opacity: 0.5;
  transition: opacity 400ms linear;

  ${props => props.focused && css`
    opacity: 1;
    font-weight: 700;
  `}
`;

export const Expiration = styled.div<{ focused?: boolean }>`
  font-family: "Bitstream Vera Sans Mono", Consolas, Courier, monospace;
  letter-spacing: 0em;
  position: relative;
  float: right;
  width: 25%;
  color: white;
  font-weight: normal;
  opacity: 0.5;
  transition: opacity 400ms linear;

  ${props => props.focused && css`
    opacity: 1;
    font-weight: 700;
  `}

  &::before {
    content: attr(data-before);
    margin-bottom: 2px;
    font-size: 7px;
    text-transform: uppercase;
    font-family: "Helvetica Neue";
    font-weight: bold;
    white-space: pre;
    display: block;
    opacity: 0.5;
  }

  &::after {
    position: absolute;
    content: attr(data-after);
    text-align: right;
    right: 100%;
    margin-right: 5px;
    margin-top: 2px;
    bottom: 0;
    font-family: "Helvetica Neue";
    font-weight: bold;
    font-size: 7px;
    white-space: pre;
    display: block;
    opacity: 0.5;
  }
`;

export const Cvc = styled.div<{ focused?: boolean; isBack?: boolean }>`
  position: absolute;
  transition-delay: 600ms;
  font-family: "Bitstream Vera Sans Mono", Consolas, Courier, monospace;
  font-size: 14px;
  color: white;
  font-weight: normal;
  opacity: 0.5;
  transition: opacity 400ms linear;

  ${props => props.focused && css`
    opacity: 1;
    font-weight: 700;
  `}

  ${props => props.isBack && css`
    top: 40%;
    left: 85%;

    ${() => IS_IE11 && css`
      transform: rotateY(180deg);
      left: 5%;
    `}
  `}

  ${Front} & {
    top: 19%;
    right: 18%;
  }
`;
